module.exports = __webpack_public_path__ + "img/section03-img01.0e8cb040.png";